/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FindAllExecutionsAvailableByFacilityId200ResponseDataInnerExecutionsHistoryInner
 */
export interface FindAllExecutionsAvailableByFacilityId200ResponseDataInnerExecutionsHistoryInner {
    /**
     * 
     */
    id: string;
    /**
     * 
     */
    facility_id: string;
    /**
     * 
     */
    lead_id: string;
    /**
     * 
     */
    createdAt: string;
    /**
     * 
     */
    lead_full_name: string;
}

/**
 * Check if a given object implements the FindAllExecutionsAvailableByFacilityId200ResponseDataInnerExecutionsHistoryInner interface.
 */
export function instanceOfFindAllExecutionsAvailableByFacilityId200ResponseDataInnerExecutionsHistoryInner(value: object): value is FindAllExecutionsAvailableByFacilityId200ResponseDataInnerExecutionsHistoryInner {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('facility_id' in value) || value['facility_id'] === undefined) return false;
    if (!('lead_id' in value) || value['lead_id'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('lead_full_name' in value) || value['lead_full_name'] === undefined) return false;
    return true;
}

export function FindAllExecutionsAvailableByFacilityId200ResponseDataInnerExecutionsHistoryInnerFromJSON(json: any): FindAllExecutionsAvailableByFacilityId200ResponseDataInnerExecutionsHistoryInner {
    return FindAllExecutionsAvailableByFacilityId200ResponseDataInnerExecutionsHistoryInnerFromJSONTyped(json, false);
}

export function FindAllExecutionsAvailableByFacilityId200ResponseDataInnerExecutionsHistoryInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): FindAllExecutionsAvailableByFacilityId200ResponseDataInnerExecutionsHistoryInner {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'facility_id': json['facility_id'],
        'lead_id': json['lead_id'],
        'createdAt': json['createdAt'],
        'lead_full_name': json['lead_full_name'],
    };
}

export function FindAllExecutionsAvailableByFacilityId200ResponseDataInnerExecutionsHistoryInnerToJSON(json: any): FindAllExecutionsAvailableByFacilityId200ResponseDataInnerExecutionsHistoryInner {
    return FindAllExecutionsAvailableByFacilityId200ResponseDataInnerExecutionsHistoryInnerToJSONTyped(json, false);
}

export function FindAllExecutionsAvailableByFacilityId200ResponseDataInnerExecutionsHistoryInnerToJSONTyped(value?: FindAllExecutionsAvailableByFacilityId200ResponseDataInnerExecutionsHistoryInner | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'facility_id': value['facility_id'],
        'lead_id': value['lead_id'],
        'createdAt': value['createdAt'],
        'lead_full_name': value['lead_full_name'],
    };
}

